import { resolveLabraProductIdForPrivateOfferNavigation } from '../../../utils/privateOfferNavigation'
import { isAzureContainerProduct } from '../../../components/MicrosoftFormComponent/ContainerPlan/containerPlanUtils'
import type { RootState } from '../../../store/types'
import type { CloudMarketplace } from '../../productsListing/types'

export const resolveProductIdForPrivateOfferFetch = (
  getState: () => RootState,
  cloud: CloudMarketplace,
  privateOfferId: string
) => {
  const products = getState().productsListing[cloud]?.products?.rows || []
  const selectedProductId = getState().productsListing[cloud]?.selectedProduct
  const currentOffer =
    getState().privateOffers?.currentPrivateOffer?.[privateOfferId]

  const offerProductRef =
    currentOffer?.labraProductId ||
    currentOffer?.cloudProductId ||
    currentOffer?.awsProductId

  return resolveLabraProductIdForPrivateOfferNavigation({
    products,
    selectedProductId,
    offerProductRef,
  })
}

export const getIsContainerProductFromState = (
  getState: () => RootState,
  cloud: CloudMarketplace
) => {
  const selectedProductId = getState().productsListing[cloud]?.selectedProduct
  const selectedProduct = getState().productsListing[
    cloud
  ]?.products?.rows.find(product => product.productId === selectedProductId)

  return isAzureContainerProduct(selectedProduct)
}
